import Icon from 'components/Icon';
import TableStaticHeadCell from 'components/Table/TableStatic/TableStaticHeadCell';
import {FC, useRef} from 'react';
import {mergeProps, useFocusRing, useTableColumnHeader} from 'react-aria';
import {Node, TableState} from 'react-stately';

type TableColumnHeaderProps = {
    column: {colspan?: number} & Node<object>;
    state: TableState<unknown>;
};

const TableColumnHeader: FC<TableColumnHeaderProps> = ({column, state}) => {
    const {allowsSorting, ...props} = column.props;

    const ref = useRef(null);
    const {columnHeaderProps} = useTableColumnHeader(
        {node: column},
        state,
        ref,
    );
    const {focusProps} = useFocusRing();

    const content = (
        <>
            {column.rendered}
            {allowsSorting && (
                <Icon
                    className="pl-1"
                    icon={
                        state.sortDescriptor?.direction === 'ascending'
                            ? 'small_arrow_up'
                            : 'small_arrow_down'
                    }
                    size="base"
                />
            )}
        </>
    );

    const optionalWrapper = allowsSorting ? (
        <div className="flex items-center">{content}</div>
    ) : (
        content
    );

    return (
        <TableStaticHeadCell
            {...mergeProps(columnHeaderProps, focusProps)}
            colSpan={column.colspan}
            ref={ref}
            {...props}
        >
            {optionalWrapper}
        </TableStaticHeadCell>
    );
};

export default TableColumnHeader;
